export function useLocationAuthLogger(_orgId: string | null): void {}
